import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZPNotification } from 'src/app/models/zpnotification';
import { AdminDashboardService } from 'src/app/services/admin-dashboard.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { Subscription } from 'rxjs';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-unlock-request-details',
  templateUrl: './unlock-request-details.component.html',
  styleUrls: ['./unlock-request-details.component.scss']
})
export class UnlockRequestDetailsComponent implements OnInit {
  @Input() public dataUser;
  @Output() public userOutputValue = new EventEmitter();
  @Output() public onClick = new EventEmitter();
  public showDetailUser: boolean;
  public user: any;
  public granted: boolean = false;
  public subscription: Subscription;
  public sharedPlan: any;
  public delegateInfo;
  public firstName: string;
  public lastName: string;
  public email: string;

  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private notifications: NotificationService,
    private api: AdminDashboardService,
    private ZpDataService: ZpDataService,
    public themeService: ThemeService) { }

  async ngOnInit() {
    let fileDelegateId = this.dataUser.data.fileDelegateId;
    let data = await this.ZpDataService.findUsers(fileDelegateId, null);
    if (data.success && data.users.length > 0) {
      data.users.forEach(element => {
        this.delegateInfo = element;
      });
      this.firstName = this.delegateInfo.firstName
      this.lastName = this.delegateInfo.lastName
      this.email = this.delegateInfo.email
    }
    this.user = this.dataUser.user
    this.showDetailUser = false;
  }

  goBack() {
    this.showDetailUser = false;
    this.onClick.emit();
  }

  async allowRequest() {
    let item = this.dataUser;
    this.granted = true;
    item.granted = this.granted;
    let res = await this.api.unlockPlan(item);
    if (res && res.success) {
      this.notifications.changeMessage(new ZPNotification("Item Saved"))
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"))
    }
  }

  async denyRequest() {
    let item = this.dataUser;
    this.granted = false;
    item.granted = this.granted;
    let res = await this.api.unlockPlan(item);
    if (res && res.success) {
      this.notifications.changeMessage(new ZPNotification("Item Saved"))
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"))
    }
  }

}
